import {logger} from 'yougile-util'
import {
  NumericIdTask,
  ReverseNumericIds,
  ReverseNumericIdsByProject,
  ReverseProjectIds
} from 'yougile-model'
import {Backend} from '@common/backend'
import {globals} from '@extensions/globals-base'

export interface FetchReverseIdTasksResult {
  reverseNumericIds?: ReverseNumericIds
  reverseNumericIdsByProject?: ReverseNumericIdsByProject
  reverseProjectIds?: ReverseProjectIds
}

export const fetchReverseIdTasks = async (
  idsTasks: NumericIdTask[]
): Promise<FetchReverseIdTasksResult | undefined> => {
  const companyId = globals.getCompanyId()

  if (!companyId || !idsTasks || idsTasks.length === 0) {
    return {}
  }

  try {
    const resp = await Backend.postJSON<FetchReverseIdTasksResult>(
      '/data/id-tasks/get-reverse-ids',
      {
        ...Backend.loadCred(),
        companyId,
        idsTasks
      }
    )

    return resp
  } catch (e) {
    logger.error('Cannot get id-task', e)
    return undefined
  }
}
